import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Country } from '@app/models/country';
import { Subscription } from 'rxjs';
import { SortService } from '../sorting/SortService';
import { InstitutionType } from '@app/models/institution';
import { CountryService } from '@app/services/shared/country.service';
import { SnackbarService } from '@app/services/shared/snackbar.service';

interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

export enum Institutionyype {
  'BRÖDRALOGE' = '4',
  'REBECKALOGE' = '13',
  'BRÖDRALÄGER' = '5',
  'REBECKALÄGER' = '16',
  'BRÖDRAFÖRENING' = '7',
  'REBECKAFÖRENING' = '15',
  'STORLOGEN' = '21',
  'BLIVANDE_MEDLEM' = '12',
  'EGL' = '9',
  'SGL' = '20',
  'F1' = '23',
  'EL' = '10'
}

@Component({
  selector: 'app-add-institution',
  templateUrl: './add-institution.component.html',
  styleUrl: './add-institution.component.css'
})



export class AddInstitutionComponent implements OnInit {
   @ViewChild('instnumber') instnumber: ElementRef;
  form;
  userpermissionlevel;
  roleid;
  selectedrole;
  userdomain;
  admininstitutionid;
  
  institutions: LodgeAndCamp[] = [];
  countries: Country[] = [];
  subscriptions: Subscription[] = [];
  institutiontypes: InstitutionType[] = [];
  
  constructor(
      private fb: FormBuilder,
      private permissionsService: PermissionsService,
      private route: ActivatedRoute,
      private institutionService: InstitutionsService,
      private countryService: CountryService,
      private snackBarService: SnackbarService,
      private router: Router,
      private messageService: MessageService,
      private confirmationService: ConfirmationService ) {

      this.ngOnInit();
    }

  ngOnInit(): void {
     this.form = this.fb.group({
          id: [null], // number
          shortName: [''],
          institutionTypeId: [null, Validators.required], // number
          institutionNumber: [null],
          name: ['', Validators.required],
          parentInstitutionId: [null],
          organizationNumber: [''],
          visitingAddress: this.fb.group({
            id: [null],
            street: [''],
            city: [''],
            country: ['']
          }),
          paymentAddress: this.fb.group({
            id: [null],
            careOf: [''],
            street: [''],
            zipCode: [''],
            city: [''],
            country: ['']
          }),
          email: [''],
          phone: [''],
          swish: [''],
          phoneMobile: [''],
          webSite: [''],
          startDate: [null, Validators.required], // Date
          endDate: [null], // Date
          bankAccount1: [''],
          bankAccount2: [''],
          installationInterval: [''],
          meetingInterval: [''],
          seat: ['']
        });

        this.permissionsService.selectedrole.subscribe(x => {
      if (x) {
        this.selectedrole = x;
        this.roleid = x.roleId;
        this.userpermissionlevel = x.userPermissionLevel;
        this.userdomain = x.userDomain;
        if (this.userpermissionlevel === 'IN' || this.userpermissionlevel === 'SY') {
          this.admininstitutionid = x.institution.id;
          this.permissionsService.admininstitutionid = this.admininstitutionid;
        }
        this.permissionsService.institutionid = Number(this.route.snapshot.params.id);
        this.permissionsService.setInstitutionAccess();
        this.permissionsService.admininstitutionid = x.institution.id;
       
        this.getInstitutionTypes();
        this.getAllInstitutions();
         this.countryService.countries$.subscribe(x => {
          if(x) {
            this.countries = x;
          }
        });
       
      }
    });
  }

  getInstitutionTypes() {
    this.subscriptions.push(this.institutionService.getInstitutionTypes().subscribe(data => {
      this.institutiontypes = data;
    }));
  }

    getAllInstitutions() {
      this.institutionService.getInstitutions().subscribe(response => {
        this.institutions = response.sort((a, b) => {
          return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
        });
        this.institutions.forEach(x => {
          x.name = x.shortName + ' ' + x.name;
        });
      });
    }

   checkNumber() {
    const checknumber = {
      institutionTypeId: Number(this.form.get('institutionTypeId').value),
      institutionNumber: Number(this.form.get('institutionNumber').value)
    };


    this.institutionService.checkInstitutionNumber(checknumber).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Institutionsnummer finns redan' });
        this.form.patchValue({ institutionNumber: '' });
        (this.instnumber.nativeElement as HTMLInputElement).focus();
      }
    });
  }

  saveForm() {
    this.subscriptions.push(this.institutionService.addInstitution(this.form.value).subscribe(data => {
        this.snackBarService.openSnackBar('Institutionen sparad.', null);
        this.router.navigate(['/institutions/id/', data]);
      }));
  }

  cancel() {
    if (this.form.dirty) {
       this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du avbryta utan att spara ändringarna?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
            this.form.reset();
            this.router.navigate(['']);
      },
      reject: () => {
      }
    });
    } else {
        this.router.navigate(['']);
    }
  }

    onSubmit() { }

     get shortName() {
    return this.form.get('shortName');
  }

  get institutionTypeId() {
    return this.form.get('institutionTypeId');
  }

  get institutionNumber() {
    return this.form.get('institutionNumber');
  }

  get name() {
    return this.form.get('name');
  }

  get organizationNumber() {
    return this.form.get('organizationNumber');
  }

  get startDate() {
    return this.form.get('startDate');
  }

  get endDate() {
    return this.form.get('endDate');
  }

}
